import { FileUtils } from "../../../../../common/utils/file_utils";
import { ICreateObrasGestaoDeResiduosUseCase } from "../../../presentation/useCases/create/create_obras_gestao_de_residuos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateObrasGestaoDeResiduosUseCase
 */

export class CreateObrasGestaoDeResiduosUseCase implements ICreateObrasGestaoDeResiduosUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createObrasGestaoDeResiduos(
    idObra?: number | null,
    classe?: string | null,
    caracteristica?: string | null,
    tipo?: string | null,
    formaSegregacao?: string | null,
    empresaGerenciadora?: string | null,
    destinacaoFinal?: string | null,
    arquivo?: File | null,
    nomeArquivo?: string | null
  ): Promise<void> {
    await this.repository.postGestaoResiduosCreate({
      idObra,
      classe,
      caracteristica,
      tipo,
      formaSegregacao,
      empresaGerenciadora,
      destinacaoFinal,
      arquivo: await FileUtils.readFileAsBase64(arquivo),
      nomeArquivo,
    });
  }
}
